import { ActivatedRoute, Router } from '@angular/router';
import { Component, OnInit, ViewChild } from '@angular/core';
import { FormArray, FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';

import { Location } from '@angular/common';
import { MainService } from '../services/main.service';
import { MatStepper } from '@angular/material/stepper';
import { RequestService } from '../services/request.service';
import Swal from 'sweetalert2';

export interface ComponentConfig {
  mode: 'create' | 'update' | 'view';
  header: {};
  pf_path: string;
  pf_name: string;
  app_cd: string;
  formData?: any;
}
@Component({
  templateUrl: './phy-file.component.html',
  styleUrls: ['./phy-file.component.css']
})

export class PhyFileComponent implements OnInit {
  requiredStepForm: FormGroup;
  additionalStepForm: FormGroup;
  innerStepperFormGroup: FormGroup;
  constructor(private fb: FormBuilder, public request: RequestService, public main: MainService, private route: ActivatedRoute, private location: Location,
    private router: Router) { }
  dsArr = []
  pfObj = {}
  lrobj = {}
  pf_tcd = [
    {
      code: 'TBL',
      value: 'Physical file is a table in a database.'
    }
  ]
  lr_typearr = [
    {
      code: 'REFERENCE',
      value: 'REFERENCE'
    },
    {
      code: 'EVENT',
      value: 'EVENT'
    }

  ]
  histarr = [
    { "code": "NH", "value": "No history is to be managed." },
    { "code": "VH", "value": "Valid time/Business effective dated history is to be managed." },
    { "code": "TH", "value": "Transaction time/Record Capture time history is to be managed." },
    { "code": "BH", "value": "Bi-Temporal i.e. both Valid time/Business effective dated and Transaction time/Record Capture time history is to be managed." }
  ]

  opr_arr = [
    {
      code: 'isInAV', value: 'Is allowed Value?'
    },
    {
      code: 'isJsonValidAgainstSchema', value: 'Is Json Valid for the Type Code?'
    },
  ]
  @ViewChild('stepper') stepper: MatStepper;
  @ViewChild('innerStepper') innerStepper: MatStepper;

  mode: any
  rrvconfig = {}
  async ngOnInit() {
    this.pfObj = this.request.pfObj
    let obj: any = this.route.snapshot.queryParamMap.get('id');
    //console.log(obj);
    let a = window.atob(obj)
    let b = JSON.parse(a);
    this.rrvconfig = b
    console.log(this.rrvconfig);
    this.mode = this.rrvconfig['mode']
    await this.intializeform()
    if (this.rrvconfig['mode'] === 'view') {

      await this.fillformwithdata(this.rrvconfig['formData'].di_id)
      this.requiredStepForm.disable();
    }

    if (this.rrvconfig['mode'] == 'create') {
      //   await this.intializeform()
    }
    if (this.rrvconfig['mode'] == 'update') {
      //  await this.intializeform()
      // let lftechnm=this.rrvconfig['formData']?.['di_tcd_json']?.['']
      // await this.getlr()
      await this.fillformwithdata(this.rrvconfig['formData'].di_id)
      this.requiredStepForm.get('lr_type').disable();
      this.requiredStepForm.get('lr_hist').disable();
    }

    await this.getAllClassifications()
    await this.getAllTerms()
    //   await this.findIds()


  }
  goBackToFirstStepper() {

    this.innerStepper.reset();


    this.stepper.selectedIndex = 0;
  }

  async intializeform() {
    this.requiredStepForm = this.fb.group({

      pf_name: ['', Validators.required],
      default_ds: ['', Validators.required],
      pf_path: ['DEFAULT'],
      pf_tcd: ['TBL'],
      di_tech_nm: [''],
      di_bus_nm: [''],
      di_desc: [''],
      di_cd: [''],
      // charset: ['utf8'],
      //  collating_seq: ['utf8_general_ci'],
      comment: [],
      lr_type: ['REFERENCE'],
      lr_hist: ['VH']


    });
  }
  async fillformwithdata(di_id) {

    await this.getPfdata(di_id)
    let formData: any = {}
    formData = this.formdata
    this.requiredStepForm.patchValue({
      pf_name: formData.di_tech_nm || '',
      default_ds: formData.di_tcd_json.default_ds.di_tech_nm || '',
      pf_path: (formData.di_tcd_json.pf_path) || 'DEFAULT',
      pf_tcd: formData.di_tcd_json.pf_tcd || 'TBL',
      di_tech_nm: formData.di_tech_nm || '',
      di_bus_nm: formData.di_bus_nm || '',
      di_desc: formData.di_desc || '',
      di_cd: formData.di_cd || '',
      //  charset: formData.di_tcd_json.charset || 'utf8',
      //  collating_seq: formData.di_tcd_json.collating_seq || 'utf8_general_ci',
      comment: formData.di_tcd_json.comment || '',
      lr_type: this.rrvconfig['formData']?.lrobj?.di_tcd_json?.lr_type || 'REFERENCE',
      lr_hist: this.rrvconfig['formData']?.lrobj?.di_tcd_json?.lr_hist || 'VH'

    });
    this.primaryKeyData.push(formData.di_tcd_json['primary_key'])
    //console.log(formData.di_tcd_json?.indexes);
    if (formData?.di_tcd_json?.indexes) {
      formData?.di_tcd_json?.indexes.forEach((ele) => {
        if (ele['unique'] == true) {
          this.uniqueKeyData.push(ele)
        }
        else {
          this.indexData.push(ele)
        }
      })
      //console.log(this.uniqueKeyData);
    }
    if (formData?.di_tcd_json?.hooks) {
      this.rows = formData?.di_tcd_json?.hooks
    }
    if (formData?.di_tcd_json?.checks) {
      this.validations = formData?.di_tcd_json?.checks
    }




  }
  async refresh() {
    // this.formdata={}
    this.rows = []
    this.uniqueKeyData = []
    this.indexData = []
    this.validations = []
    this.primaryKeyData = []


  }
  async getAllClassifications() {
    await this.getpfTcd()
    await this.getcharsetTcd()
    await this.getcollating_seqTcd()
    await this.getds()
    await this.getAllApplications()
  }
  clArr = []
  async getpfTcd() {
    this.clArr = []
    let where: any = {
      "and": [


        {
          "di_tech_nm": {
            "=": "pf_tcd"
          }
        },
        {
          "di_tcd": {
            "=": "TR"
          }
        }
      ]
    };

    let req_obj = {
      pf_path: 'dd',
      pf_name: 'di',
      app_cd: 'DD',
      filter: where,
      "include": {
        "all": true
      }

    };
    try {

      const resp = await this.main.getListData(req_obj);
      //console.log(resp);


      if (!resp.error) {
        this.clArr = resp['data'][0]['cl']

        //  this.clArr.push({ cl_cd: "APP", cl_val: "Application" })

        // Swal.fire('Deleted!', 'Node has been deleted.', 'success');




      } else {

        Swal.fire('Error!', 'Failed to get classifications.', 'error');
      }
    } catch (error) {

      //console.error('Error while getting classifications:', error);
      Swal.fire('Error!', 'Failed to get classifications.', 'error');
    }
  }
  charset = []
  async getcharsetTcd() {
    this.charset = []
    let where: any = {
      "and": [


        {
          "di_tech_nm": {
            "=": "charset"
          }
        },
        {
          "di_tcd": {
            "=": "TR"
          }
        }
      ]
    };

    let req_obj = {
      pf_path: 'dd',
      pf_name: 'di',
      app_cd: 'DD',
      filter: where,
      "include": {
        "all": true
      }

    };
    try {

      const resp = await this.main.getListData(req_obj);
      //console.log(resp);


      if (!resp.error) {
        this.charset = resp['data'][0]['cl']





      } else {

        Swal.fire('Error!', 'Failed to get classifications.', 'error');
      }
    } catch (error) {

      //console.error('Error while getting classifications:', error);
      Swal.fire('Error!', 'Failed to get classifications.', 'error');
    }
  }
  collating_seq = []
  async getcollating_seqTcd() {
    this.collating_seq = []
    let where: any = {
      "and": [


        {
          "di_tech_nm": {
            "=": "collating_seq"
          }
        },
        {
          "di_tcd": {
            "=": "TR"
          }
        }
      ]
    };

    let req_obj = {
      pf_path: 'dd',
      pf_name: 'di',
      app_cd: 'DD',
      filter: where,
      "include": {
        "all": true
      }

    };
    try {

      const resp = await this.main.getListData(req_obj);
      //console.log(resp);


      if (!resp.error) {
        this.collating_seq = resp['data'][0]['cl']





      } else {

        Swal.fire('Error!', 'Failed to get classifications.', 'error');
      }
    } catch (error) {

      //console.error('Error while getting classifications:', error);
      Swal.fire('Error!', 'Failed to get classifications.', 'error');
    }
  }
  termarr = []
  async getAllTerms() {
    this.termarr = []
    let where: any = {
      "and": [
        {
          "di_tcd": {
            "=": "TR"
          }
        }
      ]
    };

    let req_obj = {
      pf_path: 'dd',
      pf_name: 'di',
      app_cd: 'DD',
      filter: where,


    };
    try {

      const resp = await this.main.getListData(req_obj);
      //console.log(resp);


      if (!resp.error) {
        this.termarr = resp['data']
        //  this.clArr.push({ cl_cd: "APP", cl_val: "Application" })

        // Swal.fire('Deleted!', 'Node has been deleted.', 'success');




      } else {

        Swal.fire('Error!', 'Failed to get terms.', 'error');
      }
    } catch (error) {

      //console.error('Error while getting terms:', error);
      Swal.fire('Error!', 'Failed to get terms.', 'error');
    }
  }

  dsarr = []
  dsobj = {}
  async getds() {
    this.dsarr = []
    let where: any = {
      "and": [
        {
          "di_tcd": {
            "=": "DS"
          }
        }
      ]
    };

    let req_obj = {
      pf_path: 'dd',
      pf_name: 'di',
      app_cd: 'DD',
      filter: where,


    };
    try {

      const resp = await this.main.getListData(req_obj);
      //console.log(resp);


      if (!resp.error) {
        this.dsarr = resp['data']
        this.dsobj = {

        }
        this.dsarr.forEach((ele) => {
          this.dsobj[ele['di_tech_nm']] = ele['di_id']
        })
        //  this.clArr.push({ cl_cd: "APP", cl_val: "Application" })

        // Swal.fire('Deleted!', 'Node has been deleted.', 'success');




      } else {

        Swal.fire('Error!', 'Failed to get terms.', 'error');
      }
    } catch (error) {

      //console.error('Error while getting terms:', error);
      Swal.fire('Error!', 'Failed to get terms.', 'error');
    }
  }
  apparr = []
  async getAllApplications() {
    this.apparr = []
    try {
      let resp = await this.main.getAllApplications()
      if (!resp.error) {
        this.apparr = resp['data'][0]['cl']
        this.apparr = this.apparr.map((ele) => {
          ele['cl_cd'] = ele['cl_cd'].toLowerCase()
          return ele
        })
      } else {

        Swal.fire('Error!', 'Failed to get terms.', 'error');
      }
    }
    catch (error) {

      //console.error('Error while getting terms:', error);
      Swal.fire('Error!', 'Failed to get terms.', 'error');
    }

  }
  primaryKeyData = []
  addNewRecord() {

    this.uniqueKeyData.push({
      idx_keys: [],
      unique: true
    });

  }

  deleteRecord(record: any) {
    const index = this.primaryKeyData.indexOf(record);
    if (index >= 0) {
      this.primaryKeyData.splice(index, 1);

    }
  }
  uniqueKeyData = []
  deleteuniRecord(record: any) {
    const index = this.uniqueKeyData.indexOf(record);
    if (index >= 0) {
      this.uniqueKeyData.splice(index, 1);

    }
  }
  indexData = []
  deleteinRecord(record: any) {
    const index = this.indexData.indexOf(record);
    if (index >= 0) {
      this.indexData.splice(index, 1);

    }
  }
  addNewindexRecord() {

    this.indexData.push({
      idx_keys: [],
      unique: false
    });

  }
  hookNames = [

    { value: "beforeValidate", label: "beforeValidate" },
    { value: "afterValidate", label: "afterValidate" },
    { value: "beforeCreate", label: "beforeCreate" },
    { value: "afterCreate", label: "afterCreate" },
    { value: "beforeDestroy", label: "beforeDestroy" },
    { value: "afterDestroy", label: "afterDestroy" },
    { value: "beforeRestore", label: "beforeRestore" },
    { value: "afterRestore", label: "afterRestore" },
    { value: "beforeUpdate", label: "beforeUpdate" },
    { value: "afterUpdate", label: "afterUpdate" },
    { value: "beforeUpsert", label: "beforeUpsert" },
    { value: "afterUpsert", label: "afterUpsert" },
    { value: "beforeSave", label: "beforeSave" },
    { value: "afterSave", label: "afterSave" },
    { value: "beforeBulkCreate", label: "beforeBulkCreate" },
    { value: "afterBulkCreate", label: "afterBulkCreate" },
    { value: "beforeBulkDestroy", label: "beforeBulkDestroy" },
    { value: "afterBulkDestroy", label: "afterBulkDestroy" },
    { value: "beforeBulkRestore", label: "beforeBulkRestore" },
    { value: "afterBulkRestore", label: "afterBulkRestore" },
    { value: "beforeBulkUpdate", label: "beforeBulkUpdate" },
    { value: "afterBulkUpdate", label: "afterBulkUpdate" },
    { value: "beforeFind", label: "beforeFind" },
    { value: "beforeCount", label: "beforeCount" },
    { value: "beforeFindAfterExpandIncludeAll", label: "beforeFindAfterExpandIncludeAll" },
    { value: "beforeFindAfterOptions", label: "beforeFindAfterOptions" },
    { value: "afterFind", label: "afterFind" },
    { value: "beforeSync", label: "beforeSync" },
    { value: "afterSync", label: "afterSync" },
    { value: "beforeBulkSync", label: "beforeBulkSync" },
    { value: "afterBulkSync", label: "afterBulkSync" },
    { value: "beforeQuery", label: "beforeQuery" },
    { value: "afterQuery", label: "afterQuery" }
  ];


  ;
  valueOptions = ['Process 1', 'Process 2', 'Process 3'];
  rows = []

  get hooksArray() {
    //console.log(this.requiredStepForm.get('hooks'));

    return this.requiredStepForm.get('hooks') as FormArray;
  }

  createHook() {
    return this.fb.group({
      var: this.fb.group({
        name: ['', Validators.required]
      }),
      value: this.fb.group({
        name: ['', Validators.required] // Set 'afterCreateIP' as default and make it required
      })
    });
  }

  addHook() {
    this.rows.push({
      var: {
        name: ''
      },
      value: {
        name: ''
      }
    }
    );
    //console.log(this.rows)
  }

  deleteHook(index: number) {
    this.rows.splice(index, 1)
  }
  validations = []
  addvalidations() {
    this.validations.push({
      operator: {

      },
      operands: [{
        const: ''
      }]


    }
    );
    //console.log(this.validations)
  }

  deletevalidations(index: number) {
    this.validations.splice(index, 1)
  }
  async saveStep(stepper) {
    //console.log(stepper);
    if (await this.validateForm()) {
      await this.checkifrecordexistsornot()
    }





  }
  async checkifrecordexistsornot() {
    let req_obj = new Object()
    req_obj['di_tech_nm'] = this.requiredStepForm.get('pf_name').value;
    req_obj['di_tcd'] = 'PF'
    let resp = await this.main.getdtls(req_obj)
    if (resp['error'] == false) {
      //console.log(resp);
      if (resp['data'].length > 0) {
        await this.updateRecord(resp['data'][0]['di_id'])
      }
      else {
        await this.finalsave()
      }



    }
    else {

    }

  }
  async updateRecord(di_id) {
    let updateobj = {}
    let addObj = this.requiredStepForm.value
    let di_tcd_json = await this.constructditcdjson()

    updateobj = {
      "di_cd": addObj["di_cd"],
      "di_bus_nm": addObj["di_bus_nm"],
      "di_tech_nm": addObj["di_tech_nm"],
      "di_tcd": "PF",
      "di_tcd_json": di_tcd_json
    }

    let where: any = {}

    where['di_id'] = di_id

    this.main.updateData({ pf_path: 'dd', pf_name: 'di', app_cd: 'DD', set: updateobj, where: where }).then(async response => {
      if (response['error'] == false) {
        Swal.fire({
          title: 'Success!',
          text: 'Saved successfully!',
          icon: 'success',
          confirmButtonColor: '#4caf50',
          confirmButtonText: 'OK',
        });
        await this.addterms(addObj["di_tech_nm"])

        await this.refresh()
        await this.fillformwithdata(di_id)


        await this.backtolist()
      }
      else {
        Swal.fire('Error!', 'error in updating pf', 'error');
      }
      ////console.log('Data added successfully:', response);




    }).catch(error => {
      //console.error('Error updating data:', error);
    });
  }
  async finalsave() {
    //console.log(this.requiredStepForm.value, this.primaryKeyData);
    // await this.checkifrecordexistsornot()

    await this.insertLfPf()



  }


  async addterms(technm) {
    let req_obj = new Object()
    req_obj['di_tech_nm'] = technm;
    req_obj['di_tcd'] = 'LR'
    let resp = await this.main.getdtls(req_obj)
    if (resp['error'] == false) {
      //console.log(resp);
      if (resp['data'].length > 0) {
        await this.addlrtr(resp['data'][0]['di_id'])
      }
      else {
        // await this.finalsave()
      }



    }
    else {

    }


  }
  async addlrtr(di_id) {
    let where: any = {
      "and": [
        {
          "sub_di_id": {
            "=": di_id
          }
        }
      ]
    };

    let req_obj = {
      pf_path: 'dd',
      pf_name: 'dixdi',
      app_cd: 'DD',
      filter: where
    }
    try {
      const resp = await this.main.getListData(req_obj);
      //console.log(resp);

      if (!resp.error) {
        let resobj = await this.processData(resp['data'])
        await this.finaladd(resobj, di_id)
      } else {

        Swal.fire('Error!', 'error', 'error');

      }
    } catch (error) {

      //console.error('Error', error);
      Swal.fire('Error!', 'Failed to get data.', 'error');

    }



  }
  async finaladd(resobj, sub_di_id) {
    //console.log(resobj);

    await this.findIds()
    let idarr = await this.findDifference(this.keyarr, resobj['objDiIds'])
    let valarr = []
    idarr.forEach((ele, index) => {
      let itemarr = [sub_di_id, ele, 'LRTR', (resobj['maxDixdiSeqNum'] + index ), { "term_seq_num": (resobj['maxDixdiSeqNum'] + index + 1) }]
      valarr.push(itemarr)

    })
    let req_obj = new Object()
    req_obj['pf_path'] = 'dd'
    req_obj['pf_name'] = 'dixdi'
    req_obj['app_cd'] = 'DD'
    req_obj['columns'] = ['sub_di_id', 'obj_di_id', 'dixdi_tcd', 'dixdi_seq_num', 'dixdi_tcd_json']
    req_obj['values'] = valarr

    console.log(req_obj);

    try {
      let resp = await this.main.addMultiData(req_obj)

      if (!resp['error']) {
      } else {

        Swal.fire('Error!', 'Failed to insert term.', 'error');
      }
    } catch (error) {

      //console.error('Error inserting term:', error);
      Swal.fire('Error!', 'Failed to insert term.', 'error');
    }



  }
  findDifference(src, res) {
    const resSet = new Set(res);
    return src.filter(id => !resSet.has(id));
  }
  async processData(data) {
    const objDiIds = [];
    let maxDixdiSeqNum = 0;

    data.forEach(item => {
      objDiIds.push(item.obj_di_id);
      if (item.dixdi_seq_num > maxDixdiSeqNum) {
        maxDixdiSeqNum = item.dixdi_seq_num;
      }
    });

    return {
      objDiIds: objDiIds,
      maxDixdiSeqNum: maxDixdiSeqNum
    };
  }
  lflrarr = []
  async insertLfPf() {
    const pfName = this.requiredStepForm.get('pf_name').value;
    let req_obj = new Object()
    let lrobj = {}
    if (this.requiredStepForm.get('lr_type').value == 'REFERENCE') {
      lrobj['lr_type'] = this.requiredStepForm.get('lr_type').value
      lrobj['lr_hist'] = this.requiredStepForm.get('lr_hist').value

    }
    else {
      lrobj['lr_type'] = this.requiredStepForm.get('lr_type').value
    }

    req_obj['pf_path'] = 'dd'
    req_obj['pf_name'] = 'di'
    req_obj['app_cd'] = 'DD'
    req_obj['columns'] = [
      "di_bus_nm",
      "di_tech_nm",
      "di_cd",
      "di_tcd",
      "di_tcd_json"
    ]
    req_obj['values'] = [
      [
        `${pfName} logical record`,
        pfName,
        `LR-${pfName}`,
        'LR',
        lrobj
      ],
      [
        `${pfName} logical file`,
        pfName,
        `LF-${pfName}`,
        'LF',
        { "default_lr": { "di_tcd": "LR", "di_tech_nm": pfName } }
      ]

    ]
    //console.log(req_obj);

    try {
      let resp = await this.main.addMultiData(req_obj);

      if (!resp['error']) {
        //console.log(resp, 'lflrresponse');
        this.lflrarr = []
        for (let i = 0; i < resp['data'].length; i++) {
          this.lflrarr.push(resp['data'][i]['di_id'])
        }
        await this.addPFfinal()


      } else {

        Swal.fire('Error!', 'Failed to insert data.', 'error');
      }
    } catch (error) {

      //console.error('Error inserting node:', error);
      Swal.fire('Error!', 'Failed to insert node.', 'error');
    }



  }
  pfid
  async addPFfinal() {
    let addObj = this.requiredStepForm.value
    let di_tcd_json = await this.constructditcdjson()
    //console.log(addObj);

    let req_obj = new Object()
    req_obj['pf_path'] = 'dd'
    req_obj['pf_name'] = 'di'
    req_obj['app_cd'] = 'DD'
    req_obj['columns'] = [
      "di_cd",
      "di_bus_nm",
      "di_tech_nm",
      "di_desc",
      "di_tcd",
      "di_tcd_json"
    ]
    req_obj['values'] = [
      addObj['di_cd'],
      addObj['di_bus_nm'],
      addObj['di_tech_nm'],
      addObj['di_desc'],
      'PF',
      di_tcd_json



    ]
    //console.log(req_obj);

    try {
      this.pfid = null;
      let resp = await this.main.addData(req_obj);


      if (!resp['error']) {

        Swal.fire('Success!', 'PF added Successfully', 'success');
        const pfName = this.requiredStepForm.get('pf_name').value;
        //console.log(resp);
        (window as any).componentPfid = resp['data']["di_id"];
        await this.addpflf(resp['data']["di_id"])

        await this.addterms(pfName)
        await this.backtolist()

      } else {

        Swal.fire('Error!', 'Failed to insert data.', 'error');
        await this.deletelflr()
      }
    } catch (error) {

      //console.error('Error inserting node:', error);
      Swal.fire('Error!', 'Failed to insert node.', 'error');

      await this.deletelflr()


    }
  }

  async addpflf(pfid) {
    let seqfordspf = await this.getseqfordspf()
    let valarr = []
    const default_ds = this.requiredStepForm.get('default_ds').value;
    //console.log(this.dsobj[default_ds], this.dsobj, default_ds);

    valarr = [
      [this.dsobj[default_ds], pfid, 'DSPF', seqfordspf + 1, { "default": true }],
      [pfid, this.lflrarr[1], 'PFLF', 0, { "default": true }],
      [this.lflrarr[1], this.lflrarr[0], 'LFLR', 0, { "default": true }]
    ]
    let req_obj = new Object()
    req_obj['pf_path'] = 'dd'
    req_obj['pf_name'] = 'dixdi'
    req_obj['app_cd'] = 'DD'
    req_obj['columns'] = ['sub_di_id', 'obj_di_id', 'dixdi_tcd', 'dixdi_seq_num', 'dixdi_tcd_json']
    req_obj['values'] = valarr

    //console.log(req_obj);

    try {
      let resp = await this.main.addMultiData(req_obj)

      if (!resp['error']) {
      } else {

        Swal.fire('Error!', 'Failed to insert relation.', 'error');
      }
    } catch (error) {

      //console.error('Error inserting relation:', error);
      Swal.fire('Error!', 'Failed to insert relation.', 'error');
    }

  }
  async getseqfordspf() {
    let where: any = {
      "and": [
        {
          "dixdi_tcd": {
            "=": "DSPF"
          }
        }
      ]
    };

    let req_obj = {
      pf_path: 'dd',
      pf_name: 'dixdi',
      app_cd: 'DD',
      filter: where,
      "order": [["dixdi_seq_num", "DESC"]],
      "limit": 1

    }
    try {
      const resp = await this.main.getListData(req_obj);
      //console.log(resp);

      if (!resp.error) {
        return resp['data'][0]['dixdi_seq_num']

      } else {

        // Swal.fire('Error!', 'error', 'error');
        return 0;

      }
    } catch (error) {

      // //console.error('Error', error);
      // Swal.fire('Error!', 'Failed to get data.', 'error');
      return 0;

    }

  }
  async constructditcdjson() {
    let di_tcd_json: any = {};
    const formData = this.requiredStepForm.value


    if (formData.hasOwnProperty('pf_tcd') && formData['pf_tcd'] !== null) {
      di_tcd_json['pf_tcd'] = formData['pf_tcd'];
    }


    if (formData.hasOwnProperty('pf_path') && formData['pf_path'] !== null) {
      di_tcd_json['pf_path'] = formData['pf_path'];
    }


    // if (formData.hasOwnProperty('pf_name') && formData['pf_name'] !== null) {
    //   di_tcd_json['pf_name'] = formData['pf_name'];
    // }

    if (formData.hasOwnProperty('default_ds') && formData['default_ds'] !== null) {
      di_tcd_json['default_ds'] = {
        "di_tcd": "DS",
        "di_tech_nm": formData['default_ds']
      };
    }


    if (formData.hasOwnProperty('di_bus_nm') && formData['di_bus_nm'] !== null) {
      di_tcd_json['default_lf'] = {
        "di_tcd": "LF",
        "di_tech_nm": formData['di_tech_nm']
      };
    }


    // if (formData.hasOwnProperty('charset') && formData['charset'] !== null) {
    //   di_tcd_json['charset'] = formData['charset'];
    // }

    if (formData.hasOwnProperty('comment') && formData['comment'] !== null) {
      di_tcd_json['comment'] = formData['comment'];
    }
    // if (formData.hasOwnProperty('collating_seq') && formData['collating_seq'] !== null) {
    //   di_tcd_json['collating_seq'] = formData['collating_seq'];
    // }
    if (this.primaryKeyData.length > 0) {
      di_tcd_json['primary_key'] = this.primaryKeyData[0]
    }
    if (this.uniqueKeyData.length > 0) {
      // di_tcd_json['indexes'].push()
      if (di_tcd_json['indexes'] == undefined) {
        di_tcd_json['indexes'] = []
      }
      this.uniqueKeyData.forEach((ele) => {
        if (ele['idx_keys'].length > 0)
          di_tcd_json['indexes'].push(ele)
      })

    }
    if (this.indexData.length > 0) {
      // di_tcd_json['indexes'].push()
      if (di_tcd_json['indexes'] == undefined) {
        di_tcd_json['indexes'] = []
      }
      this.indexData.forEach((ele) => {
        if (ele['idx_keys'].length > 0)
          di_tcd_json['indexes'].push(ele)
      })

    }
    if (this.rows.length > 0) {
      if (di_tcd_json['hooks'] == undefined) {
        di_tcd_json['hooks'] = []
      }
      this.rows.forEach((ele) => {
        if (ele['var'].name != '' && ele['value'].name != '')
          di_tcd_json['hooks'].push(ele)
      })
    }
    if (this.validations.length > 0) {
      if (di_tcd_json['checks'] == undefined) {
        di_tcd_json['checks'] = []
      }
      this.validations.forEach((ele) => {

        di_tcd_json['checks'].push(ele)
      })
    }


    //console.log(di_tcd_json);
    return di_tcd_json

  }

  async validateForm(): Promise<boolean> {

    const formGroup = this.requiredStepForm;

    if (formGroup.valid) {
      await this.fillWithDefaults()
      let res = await this.checkforuniquekey()

      return res;

    } else {

      Object.keys(formGroup.controls).forEach((key: string) => {
        const control = formGroup.get(key);
        control.markAsTouched({ onlySelf: true });
      });
      Swal.fire('Error!', 'Form is Invalid', 'error');

      return false;
    }
  }
  async checkforuniquekey() {
    let res = (this.uniqueKeyData.length > 0) ? true : false
    if (!res)
      Swal.fire('Error!', 'please add the unique key/keys!!', 'error');
    return res


  }
  async saveInnerStep(stepper) {
    //console.log(stepper);
    //console.log(stepper);
    if (await this.validateForm()) {
      await this.checkifrecordexistsornot()
    }

  }
  async fillWithDefaults() {

    if (!this.requiredStepForm.get('di_tech_nm').value.trim()) {
      this.requiredStepForm.get('di_tech_nm').setValue(this.requiredStepForm.get('pf_name').value);
    }
    if (!this.requiredStepForm.get('di_bus_nm').value.trim()) {

      const pfPath = this.requiredStepForm.get('pf_path').value;
      const pfName = this.requiredStepForm.get('pf_name').value;
      this.requiredStepForm.get('di_bus_nm').setValue(`${pfName}`);
    }
    if (!this.requiredStepForm.get('di_cd').value.trim()) {
      const pf_name = this.requiredStepForm.get('pf_name').value;
      this.requiredStepForm.get('di_cd').setValue(`PF-${pf_name}`);
    }
    if (this.primaryKeyData.length == 0) {
      this.primaryKeyData.push({
        "pk_keys": ["row_id"], "auto_increment": true
      })
    }
  }
  async gotoAdditonal(stepper) {
    if (this.rrvconfig['mode'] == 'view') {
      stepper.next();
    }
    else {
      if (this.requiredStepForm.valid) {

        await this.fillWithDefaults();


        if (
          this.requiredStepForm.get('di_tech_nm').value &&
          this.requiredStepForm.get('di_bus_nm').value &&
          this.requiredStepForm.get('di_cd').value
        ) {

          stepper.next();
        } else {
          Swal.fire('Error!', 'Please fill in all required fields!!', 'error');
          //console.log('Please fill in all required fields with default values.');
        }
      } else {
        Swal.fire('Error!', 'Please fill in all required fields!', 'error');
        //console.log('Form is not valid.');
      }
    }


  }
  backtolist() {
    this.location.back();
  }
  formdata = {}
  async getPfdata(di_id) {
    let where: any = {
      "and": [

        {
          "di_id": {
            "=": di_id
          }
        }
      ]
    };

    let req_obj = {
      pf_path: 'dd',
      pf_name: 'di',
      app_cd: 'DD',
      filter: where,




    }
    try {
      const resp = await this.main.getListData(req_obj);
      //console.log(resp);
      if (!resp.error) {
        this.formdata = resp['data'][0]




      } else {

        Swal.fire('Error!', 'error', 'error');
      }
    } catch (error) {

      //console.error('Error', error);
      Swal.fire('Error!', 'Failed to get data.', 'error');
    }
  }
  primarr = []
  uniqarr = []
  index = []
  keyarr: any
  async findIds() {
    this.primarr = [];
    this.uniqarr = [];
    this.index = [];
    this.keyarr = new Set();


    const termMap = new Map();
    this.termarr.forEach(t => {
      if (t['di_tcd'] === 'TR') {
        termMap.set(t['di_tech_nm'], t['di_id']);
      }
    });
    const processKeys = (data, outputArray, key) => {
      data.forEach(ele => {
        ele[key].forEach(item => {
          this.keyarr.add(termMap.get(item));
          if (termMap.has(item)) {
            outputArray.push(termMap.get(item));
          }
        });
      });
    };
    processKeys(this.primaryKeyData, this.primarr, 'pk_keys');
    processKeys(this.uniqueKeyData, this.uniqarr, 'idx_keys');
    processKeys(this.indexData, this.index, 'idx_keys');
    this.keyarr = Array.from(this.keyarr);
    //console.log(this.keyarr);

  }

  async deletelflr() {

    let where: any = {
      "and": [
        {
          di_id: { "in": this.lflrarr }
        }
      ]
    };

    let req_obj = {
      pf_path: 'dd',
      pf_name: 'di',
      app_cd: 'DD',
      where: where
    };

    try {
      //console.log(req_obj);

      const resp = await this.main.deleteData(req_obj);


      if (!resp.error) {


        // Swal.fire('Deleted!', 'Term has been deleted.', 'success');

      } else {

        // Swal.fire('Error!', 'Failed to delete Term.', 'error');
      }
    } catch (error) {

      //console.error('Error deleting Term:', error);
      // Swal.fire('Error!', 'Failed to delete Term.', 'error');
    }

  }







}
